<template>
  <ul class="nav nav-mobile-menu">
    <drop-down class="custom-bullet-caret">
      <template slot="title">
        <em class="nc-icon nc-bullet-list-67"></em>
      </template>
      <div class="divider"></div>
      <a
        class="dropdown-item pointer"
        @click.prevent="block"
        style="color: black"
      >
        <em class="nc-icon nc-lock-circle-open"></em>
        {{ $t('common_words.block') }}
      </a>
      <a
        href="#"
        @click.prevent="signout"
        class="dropdown-item"
        style="color: #096537"
      >
        <em class="nc-icon nc-button-power"></em> {{ $t('common_words.exit') }}
      </a>
    </drop-down>
  </ul>
</template>
<script>
import DropDown from 'src/components/Dropdown.vue';
import { mapActions } from 'vuex';

export default {
  components: {
    DropDown,
  },
  methods: {
    // mapeamos las acciones de nuestro store para poder llamarlas desde este script
    ...mapActions({
      logout: 'auth/logout',
      cleanUserlogout: 'auth/cleanUserlogout',
    }),

    // llamamos a nuestra accion para limpiar el token, luego limpiamos el usuario
    signout() {
      this.$emit('dashLoading', true);
      this.logout().then(() => {
        this.cleanUserlogout();
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('downtime');
        this.$router.push('/login');
        this.$emit('dashLoading', false);
      });
    },

    block() {
      this.$emit('dashLoading', true);
      let data = {
        user: this.$store.state.auth.user.username,
        name:
          this.$store.state.auth.user.first_name +
          ' ' +
          this.$store.state.auth.user.last_name,
        avatar: this.$store.state.auth.user.avatar,
        active: 0,
      };
      localStorage.setItem('user', JSON.stringify(data));
      localStorage.removeItem('token');
      this.$router.push('/lock');
    },
  },
};
</script>
<style></style>
